export default __webpack_public_path__ + "662c641c12f48ff6aec7309ba0db1ec5.svg";